import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const ExpenseIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 3h14v18l-2.3-1.6-2.4 1.6-2.3-1.6L9.7 21l-2.4-1.6L5 21z" />
      <path d="M8.5 8h7M8.5 12h7M8.5 16h3" />
    </g>
  </SvgIcon>
)

export default ExpenseIcon
